// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__3VJo0","signatureButtonsRight":"ModalSign_signatureButtonsRight___m8ls"};